import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
    this.lastGoodChildren = null;
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details for debugging/telemetry
    // Replace with your logging service if available
    console.error('React ErrorBoundary caught an error:', error);
    console.error('Error info:', errorInfo);
    this.setState({ error, errorInfo });
  }

  componentDidMount() {
    // On first successful mount, keep a snapshot of children
    this.lastGoodChildren = this.props.children;
  }

  componentDidUpdate(prevProps, prevState) {
    // If last render did not error, refresh the snapshot
    if (!this.state.hasError) {
      this.lastGoodChildren = this.props.children;
    }
    // When recovering (e.g., code/state fixed), clear error state to resume normal rendering
    if (prevState.hasError && !this.state.hasError) {
      this.setState({ error: null, errorInfo: null });
    }
  }

  render() {
    if (this.state.hasError) {
      // Silently keep showing the last good UI tree; no error UI
      return this.lastGoodChildren || null;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;


